/* ==========================================================================
   WAVELESS — facets.js
   Collection/search filtering + sorting via Shopify storefront filtering
   and the Section Rendering API. Filters apply live, URL stays shareable.
   ========================================================================== */
(function () {
  'use strict';

  const form = document.getElementById('FacetsForm');
  const grid = document.getElementById('ProductGridContainer');

  // No filter sidebar (disabled in the editor): keep sorting working via
  // a plain navigation that preserves existing query params.
  if (!form) {
    const sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', sortSelect.value);
        window.location.search = params.toString();
      });
    }
    return;
  }
  if (!grid) return;

  const sectionId = grid.dataset.sectionId;
  let controller = null;

  function serialize() {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (value !== '') params.append(key, value);
    });
    return params.toString();
  }

  async function renderPage(searchParams, updateHistory) {
    grid.classList.add('loading');
    if (controller) controller.abort();
    controller = new AbortController();
    const url = window.location.pathname + '?' + searchParams + (searchParams ? '&' : '') + 'section_id=' + sectionId;
    try {
      const res = await fetch(url, { signal: controller.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      ['#ProductGridContainer', '#ShopCount', '#ActiveFacets', '#FacetsGroups'].forEach((sel) => {
        const fresh = doc.querySelector(sel);
        const current = document.querySelector(sel);
        if (fresh && current && sel !== '#ProductGridContainer') current.innerHTML = fresh.innerHTML;
        if (fresh && current && sel === '#ProductGridContainer') current.innerHTML = fresh.innerHTML;
      });
      if (updateHistory !== false) {
        window.history.pushState({ facets: searchParams }, '', window.location.pathname + (searchParams ? '?' + searchParams : ''));
      }
    } catch (e) {
      if (e.name !== 'AbortError') window.location.search = searchParams;
    } finally {
      grid.classList.remove('loading');
    }
  }

  let debounceTimer;
  form.addEventListener('change', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => renderPage(serialize()), 150);
  });
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    renderPage(serialize());
  });

  // Active filter pills + "clear all" (rendered server-side as links)
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-facet-remove]');
    if (!pill) return;
    e.preventDefault();
    const url = new URL(pill.href);
    renderPage(url.searchParams.toString());
  });

  window.addEventListener('popstate', (e) => {
    renderPage(window.location.search.replace(/^\?/, ''), false);
  });
})();
